// extracted by mini-css-extract-plugin
module.exports = {"tools":"BoardTools_tools__BA9OE"};